export const defaultTranslate = (key) => key

export const normalizePaginationParams = (params = {}) => {
    const { limit, offset } = params
    const out = {}

    if (limit !== undefined) out.limit = limit
    if (offset !== undefined && offset > 0) out.offset = offset

    return out
}

/**
 * Builds query parameters from filters object:
 * - removes null / undefined / empty string values
 * - spreads plain key-value pairs (no nesting) ex. isVisible=true instead of filters[isVisible]=true
 */
export const defaultBuildFiltersParams = (filters = {}) =>
    Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== null && value !== undefined && value !== ''))
